export const SECTION_RULES = {
  "National Articles": {
    type: "none"
  },
  "Premium & Imported": {
    type: "moq",
    value: 30
  },
  "Accessories": {
    type: "moq",
    value: 24
  },
  "Fragrance & Grooming": {
    type: "value",
    value: 2000
  },
  "Unknown Section": {
    type: "unknown"
  }
};
